/** Human-readable label for Way marketplace purchase channel. */
export function formatWayPurchaseChannel(channel?: string | null): string {
  const trimmed = String(channel ?? '').trim();
  if (!trimmed) {
    return '—';
  }
  const normalized = trimmed.toLowerCase();
  if (normalized === 'way_app') {
    return 'Way App';
  }
  if (normalized === 'way_web') {
    return 'Way Web';
  }
  return trimmed;
}
